// Import model
import { UpdateWasteFactorRequest } from '../models/UpdateWasteFactorRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateWasteFactorRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateWasteFactorRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateWasteFactorRequest instance
   */
  static deserialize(json: string): UpdateWasteFactorRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateWasteFactorRequest instance
   */
  static fromObject(obj: any): UpdateWasteFactorRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateWasteFactorRequest');
    }


    const instance: UpdateWasteFactorRequest = {
      patternTypeId: obj['patternTypeId'] as string | undefined,
      itemId: obj['itemId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateWasteFactorRequest instances
   */
  static deserializeArray(json: string): UpdateWasteFactorRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateWasteFactorRequest instance to a JSON string
   */
  static serialize(instance: UpdateWasteFactorRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateWasteFactorRequest instance to a plain object
   */
  static toObject(instance: UpdateWasteFactorRequest): any {
    return {
      'patternTypeId': instance.patternTypeId,
      'itemId': instance.itemId,
    };
  }

  /**
   * Serializes an array of UpdateWasteFactorRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateWasteFactorRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
